'use client';

import { useEffect, useState } from 'react';
import {
  CVSS_SCORE_PENDING_LOCK_MS,
  isFindingCvssScorePendingLocked,
  type FindingCvssScoreState,
} from '@terra/shared-cvss';

export function useFindingCvssPendingLock({
  finding,
  now,
}: {
  finding: FindingCvssScoreState;
  now?: Date;
}): boolean {
  const [, setLockCheck] = useState(0);
  const lockExpiresAtMs =
    now || finding.cvssScoreStatus !== 'PENDING'
      ? null
      : new Date(
          finding.cvssScoreRequestedAt ?? finding.createdAt,
        ).getTime() + CVSS_SCORE_PENDING_LOCK_MS;

  useEffect(() => {
    if (lockExpiresAtMs === null) {
      return;
    }

    const remainingMs = lockExpiresAtMs - Date.now();

    if (remainingMs <= 0) {
      return;
    }

    const timer = setTimeout(
      () => setLockCheck((count) => count + 1),
      remainingMs,
    );

    return () => clearTimeout(timer);
  }, [lockExpiresAtMs]);

  return isFindingCvssScorePendingLocked({
    finding,
    now: now ?? new Date(),
  });
}
